import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-course-change-confirm',
  templateUrl: './course-change-confirm.component.html',
  styleUrls: ['./course-change-confirm.component.scss']
})
export class CourseChangeConfirmComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<CourseChangeConfirmComponent>) { }

  ngOnInit() {
    console.log("Data", this.data);
  }
  confirm(value) {
    console.log('value', value);
    this.dialogRef.close(value)
  }

}
